
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 64 64","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M39.3 43.3c0-3.2 2.6-5.8 5.8-5.8 3.2 0 5.8 2.6 5.8 5.8s-2.6 5.8-5.8 5.8c-3.2.1-5.7-2.5-5.8-5.8zm5.9-2.7c-1.5 0-2.8 1.2-2.8 2.8 0 1.5 1.2 2.8 2.8 2.8 1.5 0 2.8-1.2 2.8-2.8-.1-1.6-1.2-2.8-2.8-2.8zM14 43.3c0-3.2 2.6-5.8 5.8-5.8s5.8 2.6 5.8 5.8c0 3.2-2.6 5.8-5.8 5.8S14 46.6 14 43.3zm3 0c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8-2.8 1.3-2.8 2.8z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M14.6 36.5c-.8 0-1.5.6-1.5 1.5s.6 1.5 1.5 1.5c9.6.2 12 4.5 12.1 4.6.3.5.8.8 1.3.8h9.4c.4 0 .7-.1 1-.4l7.8-7.2c.4-.4.6-.9.4-1.5l-6-23.9c-.1-.5-.7-1-1.4-1h-3.9c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5H38l5.5 21.8-4.9 4.5H27.1c-2.1-1.8-5.9-3.7-12.5-3.7z"}})])
          )
        }
      }
    